import { useApplicationRuntimeContext } from '@context/ApplicationRuntimeContext';
import { useUserContext } from '@context/UserContext';
import { ELoyaltyBannerType } from '@model';

export const useLoyaltyBannerType = (): ELoyaltyBannerType => {
  const {
    applicationSettings: {
      features: { enableLoyalty },
    },
  } = useApplicationRuntimeContext();
  const {
    state: { isLogged, isSubscribed },
  } = useUserContext();

  if (!enableLoyalty) {
    return ELoyaltyBannerType.DISABLED;
  }
  if (isSubscribed && isLogged) {
    return ELoyaltyBannerType.ALLOWED;
  }
  return ELoyaltyBannerType.UNAVAILABLE;
};
